import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksService from '../../util/BooksSvc/BooksSvc';
import itemOptionsReportTemplate from './itemOptionsReport.template.html';

/**
 * TODO: There is actually a duplicate code set in CSMBooksWeb/src/csmBooks/reports/itemOptionsReport/itemOptionsReport.js
 * Please read the comment in there.
 */
export default angular
  .module('books.ui.itemOptionsReport', [csmCommonWeb, booksService])
  .directive('itemOptionsReport', itemOptionsReportDirective).name;

/* @ngInject */
function itemOptionsReportDirective(BooksSvc, BusyScreen, SERVER) {
  return {
    template: itemOptionsReportTemplate,
    scope: {},
    link: function ($scope, element, attr) {
      $scope.data = {};

      /*---------------------*/
      /* Sets default values */
      /*---------------------*/
      $scope.req = {
        reportFormat: 'PDF',
        basicType: '',
        incNonOptSales: true,
        sortOptionID: 0
      };

      /*------------------------------------*/
      /* Static array of Item Sales options */
      /*------------------------------------*/
      $scope.itemSales = [
        { name: 'All Sales', code: '' },
        { name: 'Open Orders', code: 'OO' },
        { name: 'Unpaid Items', code: 'UI' },
        { name: 'Web Store', code: 'WS' }
      ];

      /*-----------------------------------------------------------*/
      /* Watches data.product and sets the itemID of the selected  */
      /* item and the sortOptions for use in the Sort By dropdown. */
      /* Returns a unique list of objects for the req.sortOptionID */
      /*-----------------------------------------------------------*/
      $scope.$watch('data.product', function (product) {
        $scope.req.itemID = product ? product.id : null;
        $scope.req.sortOptionID = 0;

        var ml = $scope.data.masterList || [];
        $scope.sortOptions = [{ id: 0, name: 'Date' }].concat(
          ($scope.data.masterList || []).filter(function (mo) {
            var optionList = [];
            var setOptions = function (pli) {
              optionList = optionList.concat(pli.itemOptions || []);

              /*------------------------------------------------------*/
              /* Loops through the subItems of the product list items */
              /*------------------------------------------------------*/
              (pli.subItems || []).forEach(setOptions);
            };

            if (product) setOptions(product);

            return (
              product &&
              optionList.some(function (io) {
                return io.optionID == mo.id;
              })
            );
          })
        );
      });

      /*--------------------------------------------------------*/
      /* Empty validation object to work with the csm-validator */
      /*--------------------------------------------------------*/
      $scope.valOption = {};
      $scope.validateInput = function () {
        return $scope.valOption.validate();
      };

      /*------------------------------------------------------------*/
      /* Watches data.options and creates a string of ID numbers of */
      /* options selected for submission. Used a watchCollection as */
      /* a regular watch is not deep enough of a watch.             */
      /*------------------------------------------------------------*/
      $scope.$watchCollection('data.options', function (option) {
        option
          ? ($scope.req.itemOptionIDs = option
              .map(function (io) {
                return io.itemOptionID;
              })
              .join(','))
          : '';
      });

      /*-------------------*/
      /* Load initial data */
      /*-------------------*/
      BooksSvc.getOrganization().then(function (resp) {
        $scope.org = resp.data;

        BooksSvc.getItemOptionMasterList(true, false).then(function (resp) {
          $scope.data.masterList = resp.data.filter(function (mo) {
            return mo.type == SERVER.BooksDBConstants.MOT_SELECTION_LIST;
          });

          BooksSvc.getProductList(null, false, false, true).then(function (
            resp
          ) {
            var productItems = resp.data.filter(function (p) {
              return p.type == SERVER.BooksDBConstants.IT_PRODUCT;
            });
            $scope.data.productList = productItems.sort(function (a, b) {
              return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });
          });
        });
        BusyScreen.setBusy(false);
      });
    }
  };
}
